export default __webpack_public_path__ + "static/media/photo-accueil.5740dc69.jpg";